<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        Вы точно хотите удалить выбранный аккаунт {{currentLeadgidAccount.name}}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteLeadgidAccount">Удалить</v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
  name: 'confirmDeletionLeadgidAccountModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
    };
  },
  computed: {
    isOpen: {
      get(){
        return this.$store.getters.GET_LEADGID_ACCOUNT_DETAILS_MODAL_CONFIRM_DELETION;
      },
      set(){
        this.$store.commit('SET_CONFIRM_DELETION_LEADGID_ACCOUNT_MODAL', false);
      }
    },
    isLoading: {
      get(){
        return this.$store.getters.GET_LEADGID_ACCOUNT_DETAILS_MODAL_CONFIRM_DELETION_LOADING;
      },
      set(value){
        this.$store.commit('SET_CONFIRM_DELETION_LEADGID_ACCOUNT_MODAL_LOADING', value);
      }
    },
    currentLeadgidAccount: {
      get(){
        return this.$store.getters.GET_CURRENT_LEADGID_ACCOUNT;
      },
      set(value){
        this.$store.commit("SET_CURRENT_LEADGID_ACCOUNT", value);
      }
    },
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.currentLeadgidAccount = {};
      this.isLoading = false;
      this.isOpen = false;
    },
    deleteLeadgidAccount(){
      this.$store.dispatch('DELETE_LEADGID_ACCOUNT', this.currentLeadgidAccount.id)
        .then(() => {
          this.$toast.success('Leadgid аккаунт был удалён');
          this.close();
        })
        .catch(() => {
          this.$toast.error('Неизвестная ошибка');
        });
    }
  },
};
</script>
